import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import 'rxjs/add/operator/map';

@Injectable()

export class CardsService {

  constructor(private http: HttpClient) { }

  userSelected() {
    return this.http.get<any>(`user/findSelection`)
      .map(response => {
        const data = response;
        return data;
      });
  }

  getCards(cardType) {
    return this.http.get<any>(`user/allCards?cardType=${cardType}`)
      .map(response => {
        const data = response;
        return data;
      });
  }

  purchaseItem(payload) {
    return this.http.post<any>(`user/selectCard`, payload)
      .map(response => {
        const data = response;
        return data;
      });
  }



}
